module.exports = __webpack_public_path__ + "img/3_x9.54d92b27.png";